import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * UK NINO generator following Single Responsibility Principle
 */
export class NinoGenerator extends BaseGenerator {
  constructor() {
    super();
    this.validFirstLetters = 'ACEGHJ-PR-TW-Z'.replace(/-/g, '').split('');
    this.validSecondLetters = 'ACEGHJ-NPR-TW-Z'.replace(/-/g, '').split('');
    this.invalidPrefixes = ['BG', 'GB', 'NK', 'KN', 'TN', 'NT', 'ZZ'];
    this.suffixLetters = ['A', 'B', 'C', 'D'];
  }

  generate() {
    let prefix;
    do {
      const firstLetter = this.validFirstLetters[this.randomInt(0, this.validFirstLetters.length - 1)];
      const secondLetter = this.validSecondLetters[this.randomInt(0, this.validSecondLetters.length - 1)];
      prefix = firstLetter + secondLetter;
    } while (this.invalidPrefixes.includes(prefix));

    const digits = this.randomDigits(6);
    const suffix = this.suffixLetters[this.randomInt(0, this.suffixLetters.length - 1)];

    return prefix + digits + suffix;
  }
}